module.exports = __webpack_public_path__ + "poppins-v5-devanagari_latin-ext_latin-700.7940efc40d8e3b477e16.ttf";


//////////////////
// WEBPACK FOOTER
// J:/Dev/Workspaces/NovaSingular/JulianaGimenez/angular/src/assets/fonts/Poppins/poppins-v5-devanagari_latin-ext_latin-700.ttf
// module id = ../../../../../src/assets/fonts/Poppins/poppins-v5-devanagari_latin-ext_latin-700.ttf
// module chunks = styles